import * as swcHelpers from '@swc/helpers';
import jwtDecode from 'jwt-decode';
import { checkSession } from './auth.js';

const audience = 'fake_https://api.local:3080/';
let tokenCache = {};
const createTokenKey = (audience1, scopes)=>`${audience1}::${scopes}`
;
const cacheToken = (accessToken)=>{
    const token = jwtDecode(accessToken);
    const tokenKey = createTokenKey(Array.isArray(token.aud) ? token.aud.join(' ') : token.aud, token.scope);
    const timeoutToken = cacheTokenWithLifetime(tokenKey, token.exp);
    tokenCache[tokenKey] = {
        token: accessToken,
        clearTimeoutToken: timeoutToken
    };
};
const clearTokenCache = ()=>{
    tokenCache = {};
};
const cacheTokenWithLifetime = (tokenKey, expiresIn)=>{
    return window.setTimeout(()=>{
        if (tokenKey in tokenCache) {
            delete tokenCache[tokenKey];
        }
    }, expiresIn * 1000 - 5000);
};
const getToken = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(...scopes) {
        const scopeString = scopes.join(' ');
        const tokenKey = createTokenKey(audience, scopeString);
        const cachedTokenEntry = tokenCache[tokenKey];
        if (cachedTokenEntry && cachedTokenEntry.token) {
            return cachedTokenEntry.token;
        }
        const authResult = yield checkSession({
            audience,
            scope: scopeString,
            responseType: 'token'
        });
        if (!authResult.accessToken) {
            throw new Error(`Did not receive accessToken from Auth0`);
        }
        if (!authResult.expiresIn) {
            throw new Error(`Did not receive accessToken expiry, received '${authResult.expiresIn}'`);
        }
        cacheToken(authResult.accessToken);
        return authResult.accessToken;
    });
    return function getToken() {
        return _ref.apply(this, arguments);
    };
}();

export { cacheToken, clearTokenCache, getToken };
//# sourceMappingURL=token-service.js.map
